import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Photorealistic, editorial-quality industrial + sustainability imagery
// Consistent color grading (cool navy + emerald + steel)
const SLIDES = [
  {
    src: "/hero/slide-1-recycling-yard.png",
    alt: "Steel recycling yard",
    caption: "Steel Recycling Yard",
  },
  {
    src: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?auto=format&fit=crop&w=1600&q=80",
    alt: "Industrial scrap processing",
    caption: "Industrial Scrap Processing",
  },
  {
    src: "/hero/slide-3-port.png",
    alt: "Container port export",
    caption: "Containers Leaving Port",
  },
  {
    src: "/hero/slide-4-logistics.png",
    alt: "Global logistics network",
    caption: "Global Logistics Network",
  },
  {
    src: "https://images.unsplash.com/photo-1516937941344-00b4e0337589?auto=format&fit=crop&w=1600&q=80",
    alt: "Circular economy",
    caption: "The Circular Economy",
  },
  {
    src: "https://images.unsplash.com/photo-1583212292454-1fe6229603b7?auto=format&fit=crop&w=1600&q=80",
    alt: "Ocean and sustainability",
    caption: "Ocean · Sustainability",
  },
];

export const HeroSlideshow = ({ height = 560 }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);
  const slide = SLIDES[idx];
  return (
    <div className="relative w-full rounded-2xl overflow-hidden bg-[#222629]" style={{ height }} data-testid="hero-slideshow">
      <AnimatePresence mode="sync">
        <motion.div
          key={idx}
          initial={{ opacity: 0, scale: 1.06 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0"
        >
          <img src={slide.src} alt={slide.alt} className="w-full h-full object-cover" loading={idx === 0 ? "eager" : "lazy"} />
          <div className="absolute inset-0 bg-gradient-to-t from-[#222629]/85 via-[#222629]/25 to-transparent" />
        </motion.div>
      </AnimatePresence>

      {/* Caption + progress dots */}
      <div className="absolute left-6 right-6 bottom-5 flex items-end justify-between gap-4 z-10">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8823E]">Sustainability in motion</div>
          <div className="font-heading text-white text-lg md:text-xl mt-1">{slide.caption}</div>
        </div>
        <div className="flex items-center gap-1.5">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Show slide ${i + 1}`}
              data-testid={`hero-slide-dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${i === idx ? "w-8 bg-[#B8823E]" : "w-3 bg-white/40 hover:bg-white/70"}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSlideshow;
